import React from 'react';
import ReactDOM from 'react-dom';
import Nav1 from "./Nav1";
import Home from "./Home";
import About from "./About";
import Skills from "./Skills";
import Education from "./Education";
import Form from "./Form"
import Footer from "./Footer"
import Demo from "./Demo"
import "./Nav1.css"
import "./Nav.css"
import "./Home.css"
import "./About.css"
import "./Skills.css"
import "./Education.css"
import "./Form.css"
import "./Footer.css"
import "./Projects.css"
import Projects from './Projects';
ReactDOM.render(
  <>
    <Nav1 />
    <Home />
    <About />
    <Skills />
    <Projects/>
    <Education />
    <Form />
    <Footer />
   
  </>,
  document.getElementById('root')
);
